import { memo } from 'react';
import { Grid } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import { TextActVM } from 'civil-status/view-models/step-form';
import { FormikErrors, FormikTouched } from 'formik';

interface FormProps {
  values?: TextActVM;
  errors?: FormikErrors<TextActVM>;
  touched?: FormikTouched<TextActVM>;
  onChange: (key: keyof TextActVM, value: TextActVM[keyof TextActVM]) => void;
  disabled?: boolean;
}

const FormComponent = ({
  disabled = false,
  values,
  errors,
  touched,
  onChange,
}: FormProps): React.ReactElement => {
  return (
    <Grid item container spacing={2} xs={12}>
      <Grid item xs={12}>
        <PmiTextField
          label="Testo dell'annotazione"
          aria-label="Testo dell'annotazione"
          id="text"
          name="text"
          fullWidth
          disabled={disabled}
          helperText={errors?.text}
          error={touched?.text && Boolean(errors?.text)}
          type="text"
          variant="outlined"
          multiline
          minRows={5}
          value={values?.text || ''}
          onChange={(event) => {
            onChange('text', event.target.value);
          }}
        />
      </Grid>
    </Grid>
  );
};

FormComponent.displayName = 'Accordion Form Text annotation old Component';

const Form = memo(FormComponent);

export default Form;
